export default __webpack_public_path__ + "images/0xf610a9dfb7c89644979b4a0f27063e9e7d7cda32.png";